import { CombinedError } from 'urql';

const STALE_BUILD_ERROR_CODES = new Set(['GRAPHQL_VALIDATION_FAILED', 'BAD_USER_INPUT']);

class StaleBuildError extends Error {}

const isStaleBuildError = (error: CombinedError): boolean =>
  error.graphQLErrors.some(({ extensions }) => {
    const { code } = extensions;
    return typeof code === 'string' && STALE_BUILD_ERROR_CODES.has(code);
  });

export { isStaleBuildError, StaleBuildError };
